export enum VisitPlanStatusEnum {
  Import = "Import",
  Ongoing = "Ongoing",
  Processing = "Processing",
  Completed = "Completed",
}


